export function toCmsMediaPath(url: string): string {
  const idx = url.indexOf('/media/');
  return idx !== -1 ? url.slice(idx) : url;
}
